import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrapper from '../components/PageWrapper';
import SEOMeta from '../components/SEOMeta';

export default function NotFoundPage() {
  return (
    <PageWrapper scrollable>
      <SEOMeta
        title="404 — Página no encontrada"
        noIndex
      />
      <Navbar />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '4rem 1rem', textAlign: 'center' }}>
        <h1 style={{ fontSize: '6rem', fontWeight: 700, color: '#69CCF0', margin: 0, lineHeight: 1 }}>404</h1>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#c0d0e0', margin: '1rem 0 0.5rem' }}>Página no encontrada</h2>
        <p style={{ color: '#8899aa', maxWidth: 400 }}>
          La ruta que buscas no existe o ha sido movida. Vuelve a la página principal de Frostbound.
        </p>
        <Link
          to="/"
          style={{ marginTop: '2rem', padding: '0.7rem 2rem', background: '#1a6fc4', color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}
        >
          Volver al inicio
        </Link>
      </main>
      <Footer />
    </PageWrapper>
  );
}
